import React from 'react';
import { ArticleSmallCardSkeleton } from '../article-small-card/ArticleSmallCard';
import * as styles from './ArticleNextPrevFooter.style';

const NextPrevFooterSkeleton = () => (
  <div css={styles.base}>
    <div css={styles.content}>
      <div css={styles.block}>
        <ArticleSmallCardSkeleton />
      </div>
      <div css={styles.block}>
        <ArticleSmallCardSkeleton />
      </div>
    </div>
  </div>
);

export default NextPrevFooterSkeleton;
